/* eslint-disable import/no-anonymous-default-export */
export default (deplete = { success: null, error: null, cost: [] }, action) => {
  switch (action.type) {
    case "DEPLETE_STOCK":
      return { ...deplete, cost: action.payload };
    case "DEPLETE_SUCCESS":
      return { ...deplete, success: action.payload, error: null };
    case "DEPLETE_ERROR":
      return { ...deplete, error: action.payload, success: null };
    default:
      return deplete;
  }
};
